import React, { useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import './EnhancementSidebar.css';

const EnhancementSidebar = ({ onEnhancementSelect, isGenerating = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const enhancements = [
    {
      id: 'orderedList',
      name: 'Ordered List',
      icon: 'list',
      description: 'Add a numbered list',
      prompt: 'Generate a relevant ordered list for this blog topic'
    },
    {
      id: 'bulletList',
      name: 'Unordered List',
      icon: 'menu',
      description: 'Add a bullet point list',
      prompt: 'Generate a relevant bullet point list for this blog topic'
    },
    {
      id: 'blockquote',
      name: 'Block Quote',
      icon: 'message-square',
      description: 'Add an inspiring quote',
      prompt: 'Generate an inspiring and relevant quote for this blog topic'
    },
    {
      id: 'ctaButton',
      name: 'CTA Button',
      icon: 'external-link',
      description: 'Add a call-to-action button',
      prompt: 'Generate a compelling call-to-action button text for this blog topic'
    },
    {
      id: 'ctaBanner',
      name: 'CTA Banner',
      icon: 'maximize',
      description: 'Add a call-to-action banner',
      prompt: 'Generate a compelling call-to-action banner text for this blog topic'
    },
    {
      id: 'visual',
      name: 'Visual',
      icon: 'image',
      description: 'Add visual content',
      prompt: 'Generate a description for visual content that would enhance this blog topic'
    },
    {
      id: 'dataVisualization',
      name: 'Data Visualization',
      icon: 'bar-chart-2',
      description: 'Add charts or graphs',
      prompt: 'Generate ideas for data visualizations that would support this blog topic'
    }
  ];

  const handleEnhancementClick = (enhancement) => {
    onEnhancementSelect(enhancement);
    setIsOpen(false);
  };

  return (
    <div className="enhancement-sidebar">
      <button
        className={`enhancement-trigger ${isOpen ? 'open' : ''} ${isGenerating ? 'generating' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        disabled={isGenerating}
        title="Add content enhancement"
      >
        <FeatherIcon 
          icon={isGenerating ? 'loader' : 'plus'} 
          size={20} 
          className={isGenerating ? 'spinning' : ''}
        />
      </button>

      {isOpen && (
        <div className="enhancement-menu">
          <div className="enhancement-menu-header">
            <h3>Blog Enhancements</h3>
            <button
              className="close-button"
              onClick={() => setIsOpen(false)}
            >
              <FeatherIcon icon="x" size={16} />
            </button>
          </div>
          
          <div className="enhancement-list">
            {enhancements.map((enhancement) => (
              <button
                key={enhancement.id}
                className="enhancement-item"
                onClick={() => handleEnhancementClick(enhancement)}
                disabled={isGenerating}
              >
                <div className="enhancement-icon">
                  <FeatherIcon icon={enhancement.icon} size={18} />
                </div>
                <div className="enhancement-content">
                  <div className="enhancement-name">{enhancement.name}</div>
                  <div className="enhancement-description">{enhancement.description}</div>
                </div>
              </button>
            ))}
          </div>
          
          <div className="enhancement-footer">
            <p>Each enhancement will be AI-generated to match your blog content.</p>
          </div>
        </div>
      )}

      {isOpen && (
        <div 
          className="enhancement-overlay" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default EnhancementSidebar; 